import { withRouter } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";

import Header from "../../../shared/header/header";
import Sidebar from "../../../shared/sidebar/sideBar";
import Taptop from "../../../shared/tap-top/tapTop";
import hasRoles from "../../../security/hasRoles";
import LandingPageFooter from "../../../shared/landing-page-footer/landing-page-footer";
import styles from "./layout.module.scss";

const AccueilLayout: React.FC = ({ children }) => {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  const keycloak = useKeycloak().keycloak;
  const hasRoleAdmin = hasRoles(["ROLE_ELEARNING_ADMIN"], keycloak);

  return (
    <>
      <Taptop />
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <Header />
        <div className="page-body-wrapper">
          {hasRoleAdmin && window.outerWidth > 992 && <Sidebar />}
          <div className={hasRoleAdmin ? `${styles["admin-page-body"]} page-body` : `${styles["user-page-body"]} page-body`}>{children}</div>
          <LandingPageFooter />
        </div>
      </div>
    </>
  );
};

export default withRouter(AccueilLayout);
